import { faDashboard } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function SideNavItem({icon,children,onClick,className, selected,nav, iconSize}) {
  const unSelectedClass = 'py-3 w-full pr-12 pl-8 text-d2 hover:pl-12 text-xs cursor-pointer hover:bg-[#2A578E] transition-all ease-linear duration-100 uppercase rounded-md'
  const selectedClass = 'py-3 w-full pr-12 pl-12 text-d2 text-xs cursor-pointer bg-[#2A578E] uppercase rounded-md transition-all ease-linear duration-200'
  return (
            <div onClick={onClick} className={`${selected?selectedClass:unSelectedClass} ${className}`}>
                {!icon?children:
                <div className='flex items-center'>
                  <button>
                      <svg fill={nav?.icon.fill} fillRule={nav?.icon.fillRule||''} clipRule={nav?.icon.clipRule||''} viewBox={nav?.icon.viewBox} height={20} width={20}><path d={nav?.icon.d}/></svg>
                  </button>
                  <div className='ml-3'>
                  {children}
                  </div>
                </div>
                }
            </div>
  )
}
